<ng-container *ngIf="isHorizontal(); else notHorizontal">
  <div class="container-horizontal" id="container" (touchstart)="handleTouch()" #container [class.reels-restoring]="restoringView()">
    <ng-container *ngFor="let noticia of noticiasFijadas(); trackBy: trackById; let i = index">
      <ng-container *ngIf="(i - 5) % 5 === 0 && ads()[(i - 5) / 5] && i != 0">
        <div class="ad">
          <a [href]="ads()[(i - 5) / 5].url">
            <img class="ad__img" [src]="ads()[(i - 5) / 5].imgUrl" />
          </a>
        </div>
      </ng-container>

      <article #noticiaElem class="noticia-horizontal" id="{{ 'noticia-' + (noticia.idVideo | kebabCase) }}">
        <ng-container *ngIf="i === 0; else notFirst">
          <div class="image-container">
            <img class="noticia-imagen" [attr.data-idvideo]="noticia.idVideo" [ngSrc]="generateMiniSrc(noticia.urlGenerica)" (error)="errorImgMini($event, noticia.urlGenerica)" alt="{{ noticia.tituloVideo }}" priority fill />
          </div>
        </ng-container>
        <ng-template #notFirst>
          <div class="image-container">
            <img class="noticia-imagen" [attr.data-idvideo]="noticia.idVideo" [ngSrc]="generateMiniSrc(noticia.urlGenerica)" (error)="errorImgMini($event, noticia.urlGenerica)" alt="{{ noticia.tituloVideo }}" loading="lazy" fill />
          </div>
        </ng-template>
        <!-- <img class="noticia-imagen" [attr.data-idvideo]="noticia.idVideo"
                [src]="noticia.urlReels ? noticia.urlReels : noticia.urlGenerica" alt="{{noticia.tituloVideo}}"> -->
        <div class="bottom-controls-horizontal">
          <div class="footer-left">
            <div class="footer-container">
              <div class="tags-horizontal">
                <ng-container *ngIf="noticia.nombre_tag">
                  <a [routerLink]="['/tag', noticia.nombre_tag | kebabCase]">
                    <span class="tags_articulo tag" [ngStyle]="{ color: noticia?.text_color_tag, 'background-color': noticia?.color_tag }">
                      {{ noticia.nombre_tag }}
                    </span>
                  </a>
                </ng-container>
                <div class="rrss-horizontal">
                  <app-rrss-buttons #shareBtnHor [url]="constantesGlobales.siteDomain + '/noticias/' + noticia?.idVideo + '/' + (noticia?.tituloSeo | kebabCase)" [text]="noticia?.tituloSeo" customClass="rrss-horizontal">
                    <mat-icon toggleIcon class="share{{ shareBtnHor.rrssVisible ? '-selected' : '' }}" aria-hidden="false" aria-label="Example home icon">share</mat-icon>
                  </app-rrss-buttons>
                </div>
              </div>

              <div class="header-article">
                <h2>
                  {{ noticia.tituloVideo }}
                </h2>
                <p id="entradilla">
                  {{ noticia.entradillaVideo }}
                </p>
              </div>
              <div class="bottom-acceder">
                <a (click)="guardarIdNoticia(noticia?.idVideo)" [routerLink]="['/noticias', noticia?.idVideo, noticia?.tituloSeo | kebabCase]"> Leer más </a>
              </div>
            </div>
          </div>
        </div>
      </article>
    </ng-container>
  </div>
</ng-container>
<ng-template #notHorizontal>
  <div class="container" id="container" (touchstart)="handleTouch()" #container [class.reels-restoring]="restoringView()">
    <ng-container *ngFor="let noticia of noticiasFijadas(); trackBy: trackById; let i = index">
      <ng-container *ngIf="(i - 5) % 5 === 0 && ads()[(i - 5) / 5] && i != 0">
        <div class="ad">
          <a [href]="ads()[(i - 5) / 5].url">
            <img class="ad__img" [src]="ads()[(i - 5) / 5].imgUrl" alt="ads" />
          </a>
        </div>
      </ng-container>

      <article #noticiaElem class="noticia" id="{{ 'noticia-' + (noticia.idVideo | kebabCase) }}">
        <div class="bottom-controls">
          <div class="footer-left">
            <div class="footer-container">
              <div class="tags">
                <ng-container *ngIf="noticia.nombre_tag">
                  <a [routerLink]="['/tag', noticia.nombre_tag | kebabCase]">
                    <span class="tags_articulo tag" [ngStyle]="{ color: noticia?.text_color_tag, 'background-color': noticia?.color_tag }">
                      {{ noticia.nombre_tag }}
                    </span>
                  </a>
                </ng-container>
              </div>
              <div class="text" (click)="mostrarEntradilla()">
                <h2>
                  {{ noticia.tituloVideo }}
                </h2>
                <p id="entradilla" [style.display]="entradillaVisible ? 'block' : 'none'">
                  {{ noticia.entradillaVideo }}
                </p>
              </div>
              <div class="bottom-acceder">
                <a (click)="guardarIdNoticia(noticia?.idVideo)" [routerLink]="['/noticias', noticia?.idVideo, noticia?.tituloSeo | kebabCase]"> Leer más </a>
              </div>
            </div>
          </div>
          <div class="footer-right">
            <div class="sidebar-icon">
              <a [routerLink]="['/autor', noticia?.id_autor, noticia?.nombre_autor | kebabCase]">
                <img src="{{ noticia.imagen_autor }}" class="userprofile" alt="{{ noticia.nombre_autor }}" style="width: 45px; height: 45px; color: rgb(97, 97, 97)" />
              </a>
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="circle-plus" class="svg-inline--fa fa-circle-plus useradd" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width: 15px; height: 15px; color: rgb(255, 0, 0)">
                <path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"></path>
              </svg>
            </div>
            <div class="sidebar-icon" (click)="guardarLike(noticia.idVideo)">
              <svg id="heart-{{ noticia.idVideo }}" [ngClass]="{ white: arraLikesComents().get(noticia.idVideo)?.likesUser?.length == 0, red: arraLikesComents().get(noticia.idVideo)?.likesUser?.length > 0 }" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="heart" class="svg-inline--fa fa-heart white" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width: 30px; height: 30px">
                <path fill="currentColor" d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"></path>
              </svg>
              <p sty>&nbsp;{{ arraLikesComents().get(noticia.idVideo)?.likes }}</p>
            </div>
            <div class="sidebar-icon" (click)="openComentariosDialog(noticia.idVideo)">
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="comment-dots" class="svg-inline--fa fa-comment-dots" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width: 30px; height: 30px; color: white">
                <path fill="currentColor" d="M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"></path>
              </svg>
              <p sty>&nbsp;{{ arraLikesComents().get(noticia.idVideo)?.coments }}</p>
            </div>
            <div class="sidebar-icon">
              <app-rrss-buttons [url]="constantesGlobales.siteDomain + '/noticias/' + noticia?.idVideo + '/' + (noticia?.tituloSeo | kebabCase)" [text]="noticia?.tituloSeo" theme="light">
                <svg toggleIcon aria-hidden="true" focusable="false" data-prefix="fas" data-icon="share" class="svg-inline--fa fa-share" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width: 30px; height: 30px; color: white">
                  <path fill="currentColor" d="M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"></path>
                </svg>
              </app-rrss-buttons>
            </div>
          </div>
        </div>
        <!-- <img [attr.data-idvideo]="noticia.idVideo" class="noticias-fondo {{animaciones[i % animaciones.length]}}"
                        [src]="noticia.urlReels ? noticia.urlReels : noticia.urlGenerica" alt="{{noticia.tituloVideo}}"> -->

        <ng-container *ngIf="i === 0; else notFirstV">
          <div class="image-container-vertical">
            <img class="noticias-fondo {{ animaciones[i % animaciones.length] }}" [attr.data-idvideo]="noticia.idVideo" [ngSrc]="noticia.urlReels ? noticia.urlReels : noticia.urlGenerica" alt="{{ noticia.tituloVideo }}" fill priority />
          </div>
        </ng-container>
        <ng-template #notFirstV>
          <div class="image-container-vertical">
            <img class="noticias-fondo {{ animaciones[i % animaciones.length] }}" [attr.data-idvideo]="noticia.idVideo" [ngSrc]="noticia.urlReels ? noticia.urlReels : noticia.urlGenerica" alt="{{ noticia.tituloVideo }}" fill loading="lazy" />
          </div>
        </ng-template>


      </article>
    </ng-container>
  </div>
</ng-template>
